module.exports = __webpack_public_path__ + "img/5-ticks.7529ea0b.webp";